var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.playstarted && !_vm.favorites)?_c('div',{staticClass:"d-flex justify-center"},[_c('flashLoader')],1):_vm._e(),(_vm.banners?.length > 0)?_c('ads-banner',{attrs:{"images":_vm.banners}}):_vm._e(),_c('div',{staticClass:"videoDimensions",class:{
      favorite1: _vm.favorites && _vm.count == 1,
      favorite2: _vm.favorites && _vm.count == 2,
      favorite3: _vm.favorites && _vm.count == 3,
      favorite4: _vm.favorites && _vm.count == 4,
    },attrs:{"id":'playerDiv' + _vm.index}},[(_vm.displaycommentaryText)?_c('div',{staticClass:"commentaryText"},[_vm._v(" "+_vm._s(_vm.commentaryText)+" ")]):_vm._e(),(_vm.messageText)?_c('marquee',{staticClass:"messageText"},[_vm._v(_vm._s(_vm.messageText))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }